import { render } from "./view-app-details.vue?vue&type=template&id=00215c6c&scoped=true"
import script from "./view-app-details.vue?vue&type=script&lang=js"
export * from "./view-app-details.vue?vue&type=script&lang=js"

import "./view-app-details.vue?vue&type=style&index=0&id=00215c6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00215c6c"]])

export default __exports__